goog.provide("shadow.js.shim.module$dayjs$locale$pt_br");
goog.provide("module$shadow_js_shim_module$dayjs$locale$pt_br");
shadow.js.shim.module$dayjs$locale$pt_br = shadow.js.nativeProvides["dayjs/locale/pt-br"] = require("dayjs/locale/pt-br");
module$shadow_js_shim_module$dayjs$locale$pt_br.default = shadow.js.shim.module$dayjs$locale$pt_br;
